import { useCallback, useMemo } from 'react';
import Mark from 'mark.js';

interface UseTextHighlighterOptions {
  selector?: string;
  delay?: number;
  enableAcrossElements?: boolean;
}

export default function useTextHighlighter({
  selector = '.highlightTarget',
  delay = 300,
  enableAcrossElements = true,
}: UseTextHighlighterOptions = {}) {
  const markInstance = useMemo(() => new Mark(selector), [selector]);

  const unMarkText = useCallback(() => {
    markInstance.unmark();
  }, [markInstance]);

  const markText = useCallback((texts: string[]) => {
    const options = { acrossElements: enableAcrossElements };
    markInstance.mark(texts, options);
  }, [enableAcrossElements, markInstance]);

  const highLightSearch = useCallback((texts: string[]) => {
    setTimeout(() => {
      unMarkText();
      markText(texts);
    }, delay);
  }, [unMarkText, markText, delay]);

  return { markText, unMarkText, highLightSearch };
}
